<template>
  <Gantt/>
  <!-- <GanttV2 v-if="company.alias == 'welink' || company.alias == 'ohla-mexico'" />
  <Gantt v-else /> -->
</template>

<script>
import Gantt from './gantt/gantt.vue';
// import Gantt from './gantt.vue'
import { mapGetters } from "vuex";



export default {
  name: 'gantt-redirect',
  middleware: 'auth',
  title: 'activities_page_title',
  subtitle: 'activities_page_subtitle',
  menuOption: '2-2',

  components: {
    Gantt
  },

  data() {
    return {
    }
  },

  computed: {
    ...mapGetters({
      company: 'app/company'
    }),
  },

  mounted() {
  },

  methods: {

  }
};
</script>
